import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import startCase from 'lodash/startCase';
import capitalize from 'lodash/capitalize';

import PaymentMethod, { CREDIT_CARD_TYPE, BUSINESS_PROFILE_TYPE, BUSINESS_ACCOUNT_TYPE } from 'models/payment-method';
import User from 'models/user';

const propTypes = {
  paymentMethod: PropTypes.instanceOf(PaymentMethod).isRequired,
  user: PropTypes.instanceOf(User).isRequired,
};

const SavedPaymentMethodLabel = ({ paymentMethod, user }) => {
  switch (paymentMethod.type) {
    case CREDIT_CARD_TYPE:
      return (
        <label>
          <span className="payment-data">
            <FormattedMessage
              id="checkout.card-label"
              defaultMessage="{cardName} ending in {cardNumber}"
              values={{
                cardName: startCase(capitalize(paymentMethod.label || paymentMethod.cardType)),
                cardNumber: paymentMethod.lastFourDigits,
              }}
            />
          </span>
        </label>
      );
    case BUSINESS_ACCOUNT_TYPE:
      return (
        <label><span className="iconified-font iconified-briefcase" /> <span className="payment-data">{paymentMethod.accountName}</span></label>
      );
    case BUSINESS_PROFILE_TYPE: {
      let connectionStatus = [];
      if (user.authorizedServices.get('concur')) {
        connectionStatus = connectionStatus.concat(
          <span key="cs-concur"><span className="iconified-font iconified-concur text-color-concur-blue" />&nbsp;
            <FormattedMessage
              id="checkout.linked-to"
              defaultMessage="Linked to {serviceName}"
              values={{ serviceName: 'Concur' }}
            />
          </span>,
        );
      }
      if (user.authorizedServices.get('expensify')) {
        connectionStatus = connectionStatus.concat(
          <span key="cs-expensify"><span className="iconified-font iconified-expensify-sm" />&nbsp;
            <FormattedMessage
              id="checkout.linked-to"
              defaultMessage="Linked to {serviceName}"
              values={{ serviceName: 'Expensify' }}
            />
          </span>,
        );
      }
      if (connectionStatus.length) {
        connectionStatus = <span>({connectionStatus})</span>;
      }
      return (
        <label><span className="iconified-font iconified-briefcase" /> <span className="payment-data">
          <FormattedMessage
            id="checkout.business-profile"
            defaultMessage="Business Profile"
          />
          {connectionStatus}
        </span></label>
      );
    }
    default:
      console.warn(`Unknown payment method type: ${paymentMethod.type}`);
      return null;
  }
};

SavedPaymentMethodLabel.propTypes = propTypes;
export default SavedPaymentMethodLabel;
